export default __webpack_public_path__ + "static/media/meetingAttendance.f911d607.png";